<template>
  <div
    class="z-20 hero-breadcrumbs-wrapper"
    :class="!customTextColor ? textColor : ''"
    data-test-id="component-hero-breadcrumbs"
    :style="customTextColor ? `color: ${customTextColor}` : ''"
  >
    <div
      class="p-0 text-tiny md:text-smallest"
      data-test-id="block-hero-breadcrumbs-list"
    >
      <template
        v-for="(breadcrumb, index) in breadcrumbs"
      >
        <div
          class="inline ml-1 font-medium uppercase align-middle first:ml-0 font-gt-america last:font-light -tracking-01-em"
          data-test-id="block-hero-breadcrumbs-item"
        >
          <MajorityUiMajorityLink
            v-if="breadcrumb.to"
            :to="breadcrumb.to"
            class="link-unstyled"
            :data-test-id="`link-hero-breadcrumbs-item-${index}`"
            tracking-name="heroBreadcrumbsButton"
            :text="breadcrumb.title"
            :callback="breadcrumb.callback ? breadcrumb.callback : () => {}"
          />
          <span
            v-else
            class="m-0"
            :data-test-id="`link-hero-breadcrumbs-item-${index}`"
          >
            {{ breadcrumb.title }}
          </span>
        </div>
        <div
          v-if="index < breadcrumbs.length - 1"
          class="relative inline-flex ml-1 uppercase align-middle first:ml-0"
        >
          <MajorityUiMajorityIcon icon="chevron-right" class="h-3 arrow-icon text-tiny md:text-smallest md:h-4" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeroBreadcrumbs',
  props: {
    breadcrumbs: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      default: 'dark',
      required: false,
      validator: value => ['light', 'dark', 'yellow'].includes(value)
    },
    customTextColor: {
      type: String,
      default: ''
    }
  },
  computed: {
    textColor () {
      switch (this.theme) {
        case 'light':
          return 'text-white'
        case 'dark':
          return 'text-dark'
        case 'yellow':
          return 'text-bright-yellow'
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.hero-breadcrumbs-wrapper {
  max-width: 90vw;
  overflow: hidden;
}
.arrow-icon {
  margin-top: -0.2rem;

  @screen md {
    margin-top: -0.1rem;
  }
}
</style>
